import { useIntl } from "@leagueplatform/locales";
import { UserSettingsLinksConfig } from "@leagueplatform/solutions-foundation";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";

export const useUserSettingsLinksConfig = () => {
  const { formatMessage } = useIntl();
  const userSettingsLinks: UserSettingsLinksConfig[] = [
    {
      heading: formatMessage({ id: "STR_ACCOUNT" }),
      items: [
        {
          text: formatMessage({ id: "STR_PERSONAL_INFORMATION" }),
          to: APP_MANAGED_ROUTES.HOME,
        },
      ],
    },
    {
      heading: formatMessage({ id: "STR_GET_SUPPORT" }),
      items: [
        {
          text: formatMessage({ id: "STR_FAQ" }),
          to: APP_MANAGED_ROUTES.HOME,
        },
        {
          text: formatMessage({ id: "STR_TECHNICAL_SUPPORT" }),
          to: APP_MANAGED_ROUTES.HOME,
        },
      ],
    },
    {
      heading: formatMessage({ id: "STR_ABOUT" }),
      items: [
        {
          text: formatMessage({ id: "STR_ABOUT_VALENCIA" }),
          to: APP_MANAGED_ROUTES.HOME,
        },
        {
          text: formatMessage({ id: "STR_GIVE_US_FEEDBACK" }),
          to: APP_MANAGED_ROUTES.HOME,
        },
        {
          text: formatMessage({ id: "STR_TERMS_OF_SERVICE" }),
          to: APP_MANAGED_ROUTES.HOME,
        },
        {
          text: formatMessage({ id: "STR_DELETE_YOUR_ACCOUNT" }),
          to: APP_MANAGED_ROUTES.HOME,
        },
      ],
    },
    {
      items: [
        {
          text: formatMessage({ id: "STR_SIGN_OUT" }),
          to: APP_MANAGED_ROUTES.SIGN_OUT,
        },
      ],
    },
  ];

  return { userSettingsLinks };
};
